import React from 'react';
import { motion } from 'framer-motion';

const MathBackground = () => {
    const symbols = [
        { sym: 'f(x)', top: '10%', left: '5%', size: 'text-4xl' },
        { sym: '∑', top: '15%', right: '10%', size: 'text-6xl' },
        { sym: '∆', bottom: '20%', left: '8%', size: 'text-5xl' },
        { sym: '∞', bottom: '15%', right: '5%', size: 'text-7xl' },
        { sym: 'π', top: '40%', right: '15%', size: 'text-3xl' },
        { sym: '∂', bottom: '40%', left: '15%', size: 'text-4xl' },
        { sym: '√', top: '70%', right: '20%', size: 'text-5xl' },
        { sym: '∫', bottom: '5%', left: '30%', size: 'text-6xl' },
        { sym: 'λ', top: '55%', left: '5%', size: 'text-3xl' },
        { sym: 'θ', bottom: '30%', right: '2%', size: 'text-4xl' },
    ];

    return (
        <div className="fixed inset-0 pointer-events-none select-none overflow-hidden z-0">
            {/* Technical Grid Overlay */}
            <div className="absolute inset-0 opacity-[0.03]"
                style={{ backgroundImage: 'radial-gradient(circle at 1px 1px, #3b82f6 1px, transparent 0)', backgroundSize: '40px 40px' }}>
            </div>

            {/* Floating Mathematical Symbols */}
            {symbols.map((item, i) => (
                <motion.div
                    key={i}
                    initial={{ opacity: 0 }}
                    animate={{
                        opacity: [0, 0.08, 0],
                        y: [0, -40, 0],
                        rotate: [0, 15, -15, 0]
                    }}
                    transition={{
                        duration: 10 + i * 2,
                        repeat: Infinity,
                        ease: "easeInOut",
                        delay: i * 0.5
                    }}
                    className={`absolute ${item.size} font-serif text-blue-500 font-light`}
                    style={{ top: item.top, left: item.left, right: item.right, bottom: item.bottom }}
                >
                    {item.sym}
                </motion.div>
            ))}

            {/* Subtle Scanning Line */}
            <motion.div
                animate={{ y: ['-100%', '200%'] }}
                transition={{ duration: 15, repeat: Infinity, ease: "linear" }}
                className="absolute inset-x-0 h-[2px] bg-gradient-to-r from-transparent via-blue-500/10 to-transparent blur-sm"
            />
        </div>
    );
};

export default MathBackground;
